export default (props, vars) => !!props?.['Icon'];
